const fonts = {
  body: 'Arial, Helvetica, sans-serif',
  heading: 'Arial, Helvetica, sans-serif',
  monospace: 'Menlo, monospace',
  roboto: 'Roboto, sans-serif',
} as const;

export default fonts;
